import { Address, addressEqual } from 'nftx.js';
import IncreaseLiquidityContainer from './IncreaseLiquidityContainer';
import usePositions from '@/application/read/positions/usePositions';
import useLiquidityPool from '@/application/read/pools/useLiquidityPool';
import useVault from '@/application/read/vaults/useVault';

export type IncreaseLiquidityProps = {
  userAddress: Address;
  positionId: Address;
  icon?: string;
  withinModal?: boolean;
};

const IncreaseLiquidityWrapper = ({
  userAddress,
  positionId,
  icon,
  withinModal = false,
}: IncreaseLiquidityProps) => {
  const { data: [, positions] = [] } = usePositions({ userAddress });
  const position = positions?.find((p) => addressEqual(p.id, positionId));
  const { data: pool } = useLiquidityPool(position?.poolId);
  const { data: vault } = useVault({ vaultId: position?.vaultId });

  if (!position || !pool || !vault) {
    return null;
  }

  return (
    <IncreaseLiquidityContainer
      pool={pool}
      position={position}
      vault={vault}
      withinModal={withinModal}
      icon={icon}
    />
  );
};

export default IncreaseLiquidityWrapper;
